module.exports = __webpack_public_path__ + "img/play.0357010b.svg";